import { useEffect, useState } from "react";
import RegisterForm from "../components/loginSession/RegisterForm";
import LoginForm from "../components/loginSession/LoginForm";
import FullModal from "../components/FullModal";
import PageTitle from "../components/PageTitle";
import { useTranslation } from 'react-i18next';

const RegisterLoginPage = () => {
    const {t} = useTranslation();
    const [section, setSection] = useState('Register');
    // Catturo la query 'section' per eventualmente swippare su login
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const section = searchParams.get('section');
        if (section) {
            setSection(section)
        }
    }, [])
    return (
        <FullModal px={4} desktopItems='center'>

            <PageTitle backLink="/" title={t('RegisterLoginPage.PageTitle')} />

            {/* Sezione registrazione */}
            {section === 'Register' && <RegisterForm setSection={setSection} />}

            {/* Sezione login */}
            {section === 'Login' && <LoginForm setSection={setSection} />}
            
        </FullModal>
    )
}

export default RegisterLoginPage;